// eslint-disable-next-line unicorn/prefer-module
const React = require('react');
// eslint-disable-next-line unicorn/prefer-module
const PropTypes = require('prop-types');
// eslint-disable-next-line unicorn/prefer-module
const NextLink = require('next/link').default;
// eslint-disable-next-line unicorn/prefer-module
const nextRoutes = require('next-routes');
// eslint-disable-next-line unicorn/prefer-module
const { useIntl } = require('react-intl');
// eslint-disable-next-line unicorn/prefer-module
const messages = require('./lib/messages');
// eslint-disable-next-line unicorn/prefer-module
const getRelativePrefix = require('./lib/getRelativePrefix');
// eslint-disable-next-line unicorn/prefer-module
const isLite = require('./lib/isLite');
// eslint-disable-next-line unicorn/prefer-module
const getPrefix = require('./lib/getPrefix');

const maybePrefix = '/:prefix(fr)?';
const keywordsParameter = ':keywords((?!in\\/).+?)';
const cityParameter = ':city(.+?)';
// eslint-disable-next-line max-len
const englishJobsPath = `/fashion-jobs{/work-at/:companySlug-jobs}?{/in/:citySlug}?{/positions/:positionSlug-jobs}?{/search/${keywordsParameter}}?{/in/${cityParameter}}?/:categoryParam(design-and-creative|internships|other|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
// eslint-disable-next-line max-len
const englishJobsCityPath = `/fashion-jobs{/work-at/:companySlug-jobs}?{/in/:citySlug}?{/positions/:positionSlug-jobs}?{/search/in/${cityParameter}}?/:categoryParam(design-and-creative|internships|other|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
const englishJobPath = '/fashion-jobs/:slug?-:id(\\d+)';
const englishJobApplyPath = '/fashion-jobs/:slug?-:id(\\d+)/apply';
// eslint-disable-next-line max-len
const germanJobsPath = `/jobs-in-der-mode{/arbeiten-bei/:companySlug-stellenangebote}?{/in/:citySlug}?{/stellen/:positionSlug-stellenangebote}?{/search/${keywordsParameter}}?{/in/${cityParameter}}?/:categoryParam(design-and-creative|internships|other|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
// eslint-disable-next-line max-len
const germanJobsCityPath = `/jobs-in-der-mode{/arbeiten-bei/:companySlug-stellenangebote}?{/in/:citySlug}?{/stellen/:positionSlug-stellenangebote}?{/search/in/${cityParameter}}?/:categoryParam(design-and-creative|internships|other|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
const germanJobPath = '/jobs-in-der-mode/:slug?-:id(\\d+)';
const germanJobApplyPath = '/jobs-in-der-mode/:slug?-:id(\\d+)/bewerben';

// eslint-disable-next-line max-len
const spanishJobsPath = `/ofertas-trabajo-moda{/trabaja-en/:companySlug-trabajos}?{/en/:citySlug}?{/puestos/:positionSlug-trabajos}?{/buscar/${keywordsParameter}}?{/en/${cityParameter}}?/:categoryParam(diseno-y-creativo|pasantias|otro|product-and-supply-chain|gestion-y-venta-en-tiendas|ventas-y-marketing)?`;
// eslint-disable-next-line max-len
const spanishJobsCityPath = `/ofertas-trabajo-moda{/trabaja-en/:companySlug-trabajos}?{/en/:citySlug}?{/puestos/:positionSlug-trabajos}?{/buscar/en/${cityParameter}}?/:categoryParam(diseno-y-creativo|pasantias|otro|product-and-supply-chain|gestion-y-venta-en-tiendas|ventas-y-marketing)?`;
const spanishJobPath = '/ofertas-trabajo-moda/:slug?-:id(\\d+)';
const spanishJobApplyPath = '/ofertas-trabajo-moda/:slug?-:id(\\d+)/solicitar';
// eslint-disable-next-line max-len
const frenchJobsMultilingualPath = `/:prefix(fr)/fashion-jobs{/travailler-chez/:companySlug-recrutement}?{/a/:citySlug}?{/fonctions/:positionSlug-emplois}?{/search/${keywordsParameter}}?{/a/${cityParameter}}?/:categoryParam(design-and-creative|internships|other|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
// eslint-disable-next-line max-len
const frenchJobsMultilingualCityPath = `/:prefix(fr)/fashion-jobs{/travailler-chez/:companySlug-recrutement}?{/a/:citySlug}?{/fonctions/:positionSlug-emplois}?{/search/a/${cityParameter}}?/:categoryParam(design-and-creative|internships|other|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
const frenchJobMultilingualPath = '/:prefix(fr)/fashion-jobs/:slug?-:id(\\d+)';
const frenchJobApplyMultilingualPath = '/:prefix(fr)/fashion-jobs'
  + '/:slug?-:id(\\d+)/postuler';
// eslint-disable-next-line max-len
const frenchJobsPath = `/fashion-jobs{/travailler-chez/:companySlug-recrutement}?{/a/:citySlug}?{/fonctions/:positionSlug-emplois}?{/search/${keywordsParameter}}?{/a/${cityParameter}}?/:categoryParam(design-and-creative|internships|other|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
// eslint-disable-next-line max-len
const frenchJobsCityPath = `/fashion-jobs{/travailler-chez/:companySlug-recrutement}?{/a/:citySlug}?{/fonctions/:positionSlug-emplois}?{/search/a/${cityParameter}}?/:categoryParam(design-and-creative|internships|other|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
const frenchJobApplyPath = '/fashion-jobs/:slug?-:id(\\d+)/postuler';
// eslint-disable-next-line max-len
const russianJobsPath = `/rabota-moda{/work-at/:companySlug-jobs}?{/in/:citySlug}?{/dolznosti/:positionSlug-vakansii}?{/search/${keywordsParameter}}?{/in/${cityParameter}}?/:categoryParam(design-and-creative|internships|other|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
// eslint-disable-next-line max-len
const russianJobsCityPath = `/rabota-moda{/work-at/:companySlug-jobs}?{/in/:citySlug}?{/dolznosti/:positionSlug-vakansii}?{/search/in/${cityParameter}}?/:categoryParam(design-and-creative|internships|other|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
const russianJobPath = '/rabota-moda/:slug?-:id(\\d+)';
const russianJobApplyPath = '/rabota-moda/:slug?-:id(\\d+)/apply';
// eslint-disable-next-line max-len
const hungarianJobsPath = `/allasok-a-divatszakmaban{/ceg/:companySlug-allasok}?{/varosok/:citySlug}?{/positions/:positionSlug-jobs}?{/search/${keywordsParameter}}?{/varosok/${cityParameter}}?/:categoryParam(dizajn-es-kreativ|gyakornok|egyeb|termek-es-ellatasi-lanc|kiskereskedelem|sales-es-marketing)?`;
// eslint-disable-next-line max-len
const hungarianJobsCityPath = `/allasok-a-divatszakmaban{/ceg/:companySlug-allasok}?{/varosok/:citySlug}?{/positions/:positionSlug-jobs}?{/search/varosok/${cityParameter}}?/:categoryParam(dizajn-es-kreativ|gyakornok|egyeb|termek-es-ellatasi-lanc|kiskereskedelem|sales-es-marketing)?`;
const hungarianJobPath = '/allasok-a-divatszakmaban/:slug?-:id(\\d+)';
const hungarianJobApplyPath = '/allasok-a-divatszakmaban'
  + '/:slug?-:id(\\d+)/jelentkezes';
// eslint-disable-next-line max-len
const italianJobsPath = `/lavorare-nella-moda{/lavori-a/:companySlug-lavori}?{/in/:citySlug}?{/posizioni/:positionSlug-jobs}?{/search/${keywordsParameter}}?{/in/${cityParameter}}?/:categoryParam(design-and-creative|internships|other|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
// eslint-disable-next-line max-len
const italianJobsCityPath = `/lavorare-nella-moda{/lavori-a/:companySlug-lavori}?{/in/:citySlug}?{/posizioni/:positionSlug-jobs}?{/search/in/${cityParameter}}?/:categoryParam(design-and-creative|internships|other|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
const italianJobPath = '/lavorare-nella-moda/:slug?-:id(\\d+)';
const italianJobApplyPath = '/lavorare-nella-moda/:slug?-:id(\\d+)/apply';
// eslint-disable-next-line max-len
const dutchJobsPath = `/modevacatures{/werken-bij/:companySlug-vacatures}?{/in/:citySlug}?{/functies/:positionSlug-banen}?{/search/${keywordsParameter}}?{/in/${cityParameter}}?/:categoryParam(design-and-creative|stages|overige|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
// eslint-disable-next-line max-len
const dutchJobsCityPath = `/modevacatures{/werken-bij/:companySlug-vacatures}?{/in/:citySlug}?{/functies/:positionSlug-banen}?{/search/in/${cityParameter}}?/:categoryParam(design-and-creative|stages|overige|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
const dutchJobPath = '/modevacatures/:slug?-:id(\\d+)';
const dutchJobApplyPath = '/modevacatures/:slug?-:id(\\d+)/solliciteer';
// eslint-disable-next-line max-len
const flemishJobsPath = `/fashion-jobs{/werken-bij/:companySlug-jobs}?{/in/:citySlug}?{/functies/:positionSlug-vacatures}?{/search/${keywordsParameter}}?{/in/${cityParameter}}?/:categoryParam(design-and-creative|stages|overige|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
// eslint-disable-next-line max-len
const flemishJobsCityPath = `/fashion-jobs{/werken-bij/:companySlug-jobs}?{/in/:citySlug}?{/functies/:positionSlug-vacatures}?{/search/in/${cityParameter}}?/:categoryParam(design-and-creative|stages|overige|product-and-supply-chain|retail-management-and-in-store|sales-and-marketing)?`;
const flemishJobApplyPath = '/fashion-jobs/:slug?-:id(\\d+)/solliciteer';

const englishJobsPositionsPath = '/fashion-jobs/positions';
const germanJobsPositionsPath = '/jobs-in-der-mode/stellen';
const spanishJobsPositionsPath = '/ofertas-trabajo-moda/puestos';
// eslint-disable-next-line max-len
const frenchJobsPositionsMultilingualPath = '/:prefix(fr)/fashion-jobs/fonctions';
const frenchJobsPositionsPath = '/fashion-jobs/fonctions';
const russianJobsPositionsPath = '/rabota-moda/dolznosti';
const hungarianJobsPositionsPath = '/allasok-a-divatszakmaban/positions';
const italianJobsPositionsPath = '/lavorare-nella-moda/posizioni';
const dutchJobsPositionsPath = '/modevacatures/functies';
const flemishJobsPositionsPath = '/fashion-jobs/functies';
const englishJobsCitiesPath = '/fashion-jobs/in';
const germanJobsCitiesPath = '/jobs-in-der-mode/in';
const spanishJobsCitiesPath = '/ofertas-trabajo-moda/en';
const frenchJobsCitiesMultilingualPath = '/:prefix(fr)/fashion-jobs/a';
const frenchJobsCitiesPath = '/fashion-jobs/a';
const russianJobsCitiesPath = '/rabota-moda/in';
const hungarianJobsCitiesPath = '/allasok-a-divatszakmaban/varosok';
const italianJobsCitiesPath = '/lavorare-nella-moda/in';
const dutchJobsCitiesPath = '/modevacatures/in';
const flemishJobsCitiesPath = '/fashion-jobs/in';
const englishCompanyProfilesPath = '/fashion-jobs/work-at';
const germanCompanyProfilesPath = '/jobs-in-der-mode/arbeiten-bei';
const spanishCompanyProfilesPath = '/ofertas-trabajo-moda/trabaja-en';
// eslint-disable-next-line max-len
const frenchCompanyProfilesMultilingualPath = '/:prefix(fr)/fashion-jobs/Travailler-chez';
const frenchCompanyProfilesPath = '/fashion-jobs/Travailler-chez';
const russianCompanyProfilesPath = '/rabota-moda/work-at';
const hungarianCompanyProfilesPath = '/allasok-a-divatszakmaban/work-at';
const italianCompanyProfilesPath = '/lavorare-nella-moda/lavori-a';
const dutchCompanyProfilesPath = '/modevacatures/werken-bij';
const flemishCompanyProfilesPath = '/fashion-jobs/werken-bij';

const englishJobsLandingPath = '/fashionjobs';
const ukJobsLandingPath = '/career-centre';
const germanJobsLandingPath = '/stellenmarkt-der-modebranche';
const spanishJobsLandingPath = '/bolsa-de-trabajo-en-moda';
const frenchJobsLandingPath = '/fashion-jobs-offres-d-emploi-mode';
// eslint-disable-next-line max-len
const frenchJobsLandingMultilingualPath = '/:prefix(fr)/fashion-job-recrutement';
const italianJobsLandingPath = '/centro-carriera';
const flemishJobsLandingPath = '/mode-jobs';
const dutchJobsLandingPath = '/mode-vacatures';
const russianJobsLandingPath = '/rabota-v-industrii-mody';

// eslint-disable-next-line max-len
const englishProfilePagePath = '/fashion-jobs/work-at/:companySlug-jobs/:profilePage(about|news|working-at)';
// eslint-disable-next-line max-len
const germanProfilePagePath = '/jobs-in-der-mode/arbeiten-bei/:companySlug-stellenangebote/:profilePage(about|news|working-at)';
// eslint-disable-next-line max-len
const spanishProfilePagePath = '/ofertas-trabajo-moda/trabaja-en/:companySlug-trabajos/:profilePage(about|news|working-at)';
// eslint-disable-next-line max-len
const frenchProfilePageMultilingualPath = '/:prefix(fr)/fashion-jobs/travailler-chez/:companySlug-recrutement/:profilePage(about|news|working-at)';
// eslint-disable-next-line max-len
const frenchProfilePagePath = '/fashion-jobs/travailler-chez/:companySlug-recrutement/:profilePage(about|news|working-at)';
// eslint-disable-next-line max-len
const russianProfilePagePath = '/rabota-moda/work-at/:companySlug-jobs/:profilePage(about|news|working-at)';
// eslint-disable-next-line max-len
const hungarianProfilePagePath = '/allasok-a-divatszakmaban/ceg/:companySlug-allasok/:profilePage(about|news|working-at)';
// eslint-disable-next-line max-len
const italianProfilePagePath = '/lavorare-nella-moda/lavori-a/:companySlug-lavori/:profilePage(about|news|working-at)';
// eslint-disable-next-line max-len
const dutchProfilePagePath = '/modevacatures/werken-bij/:companySlug-vacatures/:profilePage(about|news|working-at)';
// eslint-disable-next-line max-len
const flemishProfilePagePath = '/fashion-jobs/werken-bij/:companySlug-jobs/:profilePage(about|news|working-at)';

const englishEBPEditPath = '/fashion-jobs/work-at/:companySlug-jobs/edit';
// eslint-disable-next-line max-len
const germanEBPEditPath = '/jobs-in-der-mode/arbeiten-bei/:companySlug-stellenangebote/edit';
// eslint-disable-next-line max-len
const spanishEBPEditPath = '/ofertas-trabajo-moda/trabaja-en/:companySlug-trabajos/edit';
// eslint-disable-next-line max-len
const frenchEBPEditMultilingualPath = '/:prefix(fr)/fashion-jobs/travailler-chez/:companySlug-recrutement/edit';
// eslint-disable-next-line max-len
const frenchEBPEditPath = '/fashion-jobs/travailler-chez/:companySlug-recrutement/edit';
const russianEBPEditPath = '/rabota-moda/work-at/:companySlug-jobs/edit';
// eslint-disable-next-line max-len
const hungarianEBPEditPath = '/allasok-a-divatszakmaban/ceg/:companySlug-allasok/edit';
// eslint-disable-next-line max-len
const italianEBPEditPath = '/lavorare-nella-moda/lavori-a/:companySlug-lavori/edit';
// eslint-disable-next-line max-len
const dutchEBPEditPath = '/modevacatures/werken-bij/:companySlug-vacatures/edit';
const flemishEBPEditPath = '/fashion-jobs/werken-bij/:companySlug-jobs/edit';

const englishNewsFeedPath = '/just-in';
const frenchNewsFeedPath = '/fil-info';
const frenchNewsFeedMultilingualPath = '/:prefix(fr)/fil-info';
const dutchNewsFeedPath = '/net-binnen';
const spanishNewsFeedPath = '/ultima-hora';
const germanNewsFeedPath = '/aktuell';
const italianNewsFeedPath = '/ultima-ora';
const portugueseNewsFeedPath = '/ultimas';

// eslint-disable-next-line max-len
const categoryPath = ':categoryPath(actualite|actualite/business|actualite/culturelle|actualite/mode|actualite/people|actualite/podcast|actualite/retail|actualite/salons|actualite/historique|actualite/video|featured-in|nachrichten|nachrichten/business|nachrichten/einzelhandel|nachrichten/kultur|nachrichten/messen|nachrichten/mode|nachrichten/personen|nachrichten/hintergrund|nachrichten/podcast|nachrichten/video|news|news/business|news/cultura|news/culture|news/fairs|news/background|news/fashion|news/fiere|news/moda|news/people|news/persone|news/podcast|news/retail|news/video|nieuws|nieuws/beurzen|nieuws/business|nieuws/cultuur|nieuws/mensen|nieuws/mode|nieuws/multi|nieuws/podcast|nieuws/retail|nieuws/achtergrond|nieuws/video|noticias|noticias/cultura|noticias/empresas|noticias/ferias|noticias/gente|noticias/moda|noticias/podcast|noticias/retail|noticias/contexto|noticias/video|notizie/sfondo|notícias/histórico|press|press/business|press/celebridades|press/celebrity|press/cultura|press/culture|press/cultuur|press/einzelhandel|press/empresas|press/event|press/eventi|press/eventos|press/events|press/fashion|press/gente|press/investigacion|press/kultur|press/ling-shou-ye|press/mensen|press/ming-ren|press/moda|press/mode|press/people|press/persone|press/personen|press/ren|press/ren-wu|press/research|press/retail|press/ricerca|press/shang-wu|press/shi-shang|press/veranstaltungen|press/wen-hua|press/beeznyes|press/znamyeneetostee|press/eesslyedovaneeya|press/kulstura|press/leechnostee|press/reetyeil|presse|presse/business|presse/culture|presse/evenements|presse/mode|presse/people|presse/personnalites|presse/recherche|presse/retail|v1|v1/apparel|v1/columns|v1/design|v1/fashion|v1/fashion-news|v1/leads|v1/moda|v1/mode|v1/mode-nachrichten|v1/show|v1/shows-mode|v1/trends|v1/video|xin-wen|xin-wen/huo-dong|xin-wen/ling-shou-ye|xin-wen/podcast|xin-wen/ren|xin-wen/shang-wu|xin-wen/shi-shang|xin-wen/video|xin-wen/wen-hua|novostee|novostee/podcast|novostee/beeznyes|novostee/veedyeo|novostee/vistavkee|novostee/kulstura|novostee/leechnostee|novostee/moda|novostee/reetyeil|uncategorised|education|education/news|education/schools|executive|executive/management|executive/report|press)';

const englishLocalesWithoutUk = [
  'en-AU', 'en-CA', 'en-IE', 'en-IN', 'en-NZ', 'en-US',
];
const ukLocales = ['en-GB'];
const englishLocales = [...englishLocalesWithoutUk, ...ukLocales];
const germanLocales = ['de-AT', 'de-CH', 'de-DE'];
const spanishLocales = ['es-AR', 'es-CL', 'es-CO', 'es-ES', 'es-MX', 'es-PE'];
const frenchOnlyLocales = ['fr-FR', 'fr-LU'];
const frenchNonMultilingualLocales = [...frenchOnlyLocales, 'fr-CH'];
const frenchMultilingualLocales = ['fr-BE', 'fr-CA'];
const netherlandsLocales = ['nl-NL'];
const flemishLocales = ['nl-BE'];
const dutchLocales = [...netherlandsLocales, ...flemishLocales];
const russianLocales = ['ru-RU'];
const italyLocales = ['it-IT'];
const italianLocales = [...italyLocales, 'it-CH'];
const hungarianLocales = ['hu-HU'];
const swissAlternativeLocales = ['fr-CH', 'it-CH'];
const portugueseLocales = ['pt-BR', 'pt-PT'];
const untranslatedLocales = [
  'cs-CZ',
  'da-DK',
  'fi-FI',
  'ja-JP',
  'nb-NO',
  'pl-PL',
  'sv-SE',
  'tr-TR',
  'zh-CN',
  'zh-HK',
];
const categoryTagPage = ':page(trends|fashion-week-web|education|executive)';

function addPathForLocales(route, path, locales, page = route) {
  return locales
    .reduce((routes, locale) => routes
      .add(`${route}.${locale}`, path, page), this);
}

const defineAddPathForLocales = (routes) => {
  // eslint-disable-next-line no-param-reassign
  routes.addPathForLocales = addPathForLocales;

  return routes;
};

const isLiteInBrowser = process.browser
  && isLite(getPrefix(window.location.href));

// I need to include this package in order to fix this bug easier:
// https://github.com/zeit/next.js/issues/5214
const routes = defineAddPathForLocales(nextRoutes())
  .add(
    'index',
    maybePrefix,
    isLiteInBrowser ? 'landing' : 'index',
  )
  .add(
    'appShell',
    `${maybePrefix}/app-shell/:locale`,
    'appShell',
  )
  .add('news-form', '/news-articles/new', 'news-form')
  .add('news-form-success', '/news-articles/new/success', 'news-form-success')
  .add('profiles-brands', '/profiles-brands', 'profiles-brands')
  .add('access-requests', '/access-requests', 'access-requests')
  .add('lookbookCategories', '/lookbook/categories', 'lookbook/categories')
  .add(
    'lookbookCategory',
    '/lookbook/categories/:slug-:categoryId(\\d+){/search/:search(.*)}?',
    'lookbook/category',
  )
  .add('lookbook', '/lookbook{/search/:search(.*)}?', 'lookbook')
  .add('lookbookUpload', '/lookbook/upload', 'lookbook/upload')
  .add('lookbookImage', '/lookbook/{:slug-}?:id(\\d+)', 'lookbook/image')
  .add(
    'case',
    `${maybePrefix}/case/:slug`,
    'case',
  )
  .add(
    'search',
    `${maybePrefix}/:searchPath(search|zoek|such-ergebnis|\
recherche|buscador|ricerca)`,
    'search',
  )
  .add(
    'tags',
    `${maybePrefix}/tags`,
    'tags',
  )
  .add(
    'author',
    `${maybePrefix}/authors/:authorSlug`,
    'author',
  )
  .addPathForLocales(
    'news-feed',
    frenchNewsFeedMultilingualPath,
    frenchMultilingualLocales,
  )
  .addPathForLocales(
    'news-feed',
    frenchNewsFeedPath,
    frenchNonMultilingualLocales,
  )
  .addPathForLocales(
    'news-feed',
    spanishNewsFeedPath,
    spanishLocales,
  )
  .addPathForLocales(
    'news-feed',
    germanNewsFeedPath,
    germanLocales,
  )
  .addPathForLocales(
    'news-feed',
    dutchNewsFeedPath,
    dutchLocales,
  )
  .addPathForLocales(
    'news-feed',
    italianNewsFeedPath,
    italianLocales,
  )
  .addPathForLocales(
    'news-feed',
    portugueseNewsFeedPath,
    portugueseLocales,
  )
  .addPathForLocales(
    'news-feed',
    englishNewsFeedPath,
    [
      ...englishLocales,
      ...untranslatedLocales,
      ...hungarianLocales,
      ...russianLocales,
    ],
  )
  .addPathForLocales(
    'jobs-landing',
    englishJobsLandingPath,
    [
      ...englishLocalesWithoutUk,
      ...untranslatedLocales,
      ...portugueseLocales,
      ...hungarianLocales,
    ],
  )
  .addPathForLocales(
    'jobs-landing',
    ukJobsLandingPath,
    ukLocales,
  )
  .addPathForLocales(
    'jobs-landing',
    germanJobsLandingPath,
    [
      ...germanLocales,
      ...swissAlternativeLocales,
    ],
  )
  .addPathForLocales(
    'jobs-landing',
    spanishJobsLandingPath,
    spanishLocales,
  )
  .addPathForLocales(
    'jobs-landing',
    frenchJobsLandingMultilingualPath,
    frenchMultilingualLocales,
  )
  .addPathForLocales(
    'jobs-landing',
    frenchJobsLandingPath,
    frenchOnlyLocales,
  )
  .addPathForLocales(
    'jobs-landing',
    italianJobsLandingPath,
    italyLocales,
  )
  .addPathForLocales(
    'jobs-landing',
    flemishJobsLandingPath,
    flemishLocales,
  )
  .addPathForLocales(
    'jobs-landing',
    dutchJobsLandingPath,
    netherlandsLocales,
  )
  .addPathForLocales(
    'jobs-landing',
    russianJobsLandingPath,
    russianLocales,
  )
  .add(
    'partners',
    '/:prefix(fr)?/partners',
    'partners',
  )
  .add(
    'tag',
    `${maybePrefix}/tags/:slug(.*)`,
    'tag',
  )
  .add(
    'trends',
    `${maybePrefix}/trends`,
    'trends',
  )
  .add(
    'fashion-week-web',
    `${maybePrefix}/fashion-week-web`,
    'fashion-week-web',
  )
  .add(
    'education',
    `${maybePrefix}/education`,
    'education',
  )
  .add(
    'executive',
    `${maybePrefix}/executive`,
    'executive',
  )
  .add(
    'company-profile',
    `${maybePrefix}/companies/:slug`,
    'company-profile',
  )
  .add(
    'company-profile-products',
    `${maybePrefix}/companies/:slug/products`,
    'company-profile-products',
  )
  .add(
    'company-profile-product',
    `${maybePrefix}/companies/:slug/products/:id`,
    'company-profile-product',
  )
  .add(
    'fashion-finder',
    `${maybePrefix}/fashion-finder`,
    'fashion-finder',
  )
  .add(
    'fashion-finder-profile',
    `${maybePrefix}/find/:slug/products`,
    'fashion-finder-profile',
  )
  .add(
    'fashion-finder-product',
    `${maybePrefix}/find/:slug/products/:id`,
    'fashion-finder-product',
  )
  .add(
    'company-profile-edit',
    `${maybePrefix}/companies/:slug/edit`,
    'company-profile-edit',
  )
  .add(
    'school-profile-courses',
    `${maybePrefix}/companies/:slug/courses`,
    'school-profile-courses',
  )
  .add(
    'courses',
    `${maybePrefix}/education/courses`,
    'courses',
  )
  .add(
    'course',
    `${maybePrefix}/education/courses/:id-:slug`,
    'course',
  )
  .add(
    'product',
    `${maybePrefix
    }{/markets/:marketId(\\d+)}?{/stands/:standId(\\d+)}?/products/:id`,
    'product',
  )
  .add(
    'market-brands',
    `${maybePrefix}/markets/:marketId(\\d+)/brands`,
    'market-brands',
  )
  .add(
    'brands-directory',
    `${maybePrefix}/brands{/:section(all)}?`,
    'brands-directory',
  )
  .add(
    'schools-directory',
    `${maybePrefix}/schools{/:section(all)}?`,
    'schools-directory',
  )
  .add(
    'company-directory',
    `${maybePrefix}/companies`,
    'company-directory',
  )
  .add(
    'federations-directory',
    `${maybePrefix}/federations{/:section(all)}?`,
    'federations-directory',
  )
  .add(
    'manufacturer-directory',
    `${maybePrefix}/manufacturers{/:section(all)}?`,
    'manufacturer-directory',
  )
  .add(
    'software-suppliers-directory',
    `${maybePrefix}/software-suppliers{/:section(all)}?`,
    'software-suppliers-directory',
  )
  .add(
    'fashionweeks-directory',
    `${maybePrefix}/fashion-weeks{/:section(all)}?`,
    'fashionweeks-directory',
  )
  .add(
    'agency-directory',
    `${maybePrefix}/agencies{/:section(all)}?`,
    'agency-directory',
  )
  .add(
    'retail-directory',
    `${maybePrefix}/retailers{/:section(all)}?`,
    'retail-directory',
  )
  .add(
    'specials',
    `${maybePrefix}/specials/:slug`,
    'specials',
  )
  .add(
    'events',
    `${maybePrefix}/:eventsPath(events|eventos|veranstaltungen|\
evenementen|evenements|eventi|kalendar)`,
    'events',
  )
  .add(
    'event',
    `${maybePrefix}/:eventsPath(events|eventos|veranstaltungen|\
evenementen|evenements|eventi|kalendar)/:slug`,
    'event',
  )
  .add(
    'products',
    `${maybePrefix
    }{/markets/:marketId(\\d+)}?{/stands/:standId(\\d+)}?/products`,
    'products',
  )
  .add(
    'markets',
    `${maybePrefix}/markets`,
    'markets',
  )
  .add(
    'market',
    `${maybePrefix}/markets/:marketId(\\d+)`,
    'market',
  )
  .add(
    'stands',
    `${maybePrefix}/markets/:marketId(\\d+)/stands`,
    'stands',
  )
  .add(
    'stand',
    `${maybePrefix}/markets/:marketId(\\d+)/stands/:standId(\\d+)`,
    'stand',
  )
  .add(
    'login',
    `${maybePrefix}/login`,
    'login',
  )
  .add(
    'logout',
    `${maybePrefix}/logout`,
    'logout',
  )
  .add(
    'register',
    `${maybePrefix}/register`,
    'register',
  )
  .add(
    'register-buyer',
    `${maybePrefix}/marketplace/buyers`,
    'register-buyer',
  )
  .add(
    'reset-password',
    `${maybePrefix}/reset-password`,
    'reset-password',
  )
  .add(
    'change-password',
    `${maybePrefix}/change-password`,
    'change-password',
  )
  .add(
    'profile',
    `${maybePrefix}/profile`,
    'profile',
  )
  .add(
    'edit-user-profile',
    `${maybePrefix}/profile/edit`,
    'edit-user-profile',
  )
  .addPathForLocales(
    'jobs-positions',
    englishJobsPositionsPath,
    [
      ...untranslatedLocales,
      ...portugueseLocales,
      ...englishLocales,
    ],
  )
  .addPathForLocales(
    'jobs-positions',
    germanJobsPositionsPath,
    germanLocales,
  )
  .addPathForLocales(
    'jobs-positions',
    spanishJobsPositionsPath,
    spanishLocales,
  )
  .addPathForLocales(
    'jobs-positions',
    frenchJobsPositionsMultilingualPath,
    frenchMultilingualLocales,
  )
  .addPathForLocales(
    'jobs-positions',
    frenchJobsPositionsPath,
    frenchNonMultilingualLocales,
  )
  .addPathForLocales(
    'jobs-positions',
    hungarianJobsPositionsPath,
    hungarianLocales,
  )
  .addPathForLocales(
    'jobs-positions',
    italianJobsPositionsPath,
    italianLocales,
  )
  .addPathForLocales(
    'jobs-positions',
    flemishJobsPositionsPath,
    flemishLocales,
  )
  .addPathForLocales(
    'jobs-positions',
    dutchJobsPositionsPath,
    netherlandsLocales,
  )
  .addPathForLocales(
    'jobs-positions',
    russianJobsPositionsPath,
    russianLocales,
  )
  .addPathForLocales(
    'jobs-cities',
    englishJobsCitiesPath,
    [
      ...untranslatedLocales,
      ...portugueseLocales,
      ...englishLocales,
    ],
  )
  .addPathForLocales(
    'jobs-cities',
    germanJobsCitiesPath,
    germanLocales,
  )
  .addPathForLocales(
    'jobs-cities',
    spanishJobsCitiesPath,
    spanishLocales,
  )
  .addPathForLocales(
    'jobs-cities',
    frenchJobsCitiesMultilingualPath,
    frenchMultilingualLocales,
  )
  .addPathForLocales(
    'jobs-cities',
    frenchJobsCitiesPath,
    frenchNonMultilingualLocales,
  )
  .addPathForLocales(
    'jobs-cities',
    hungarianJobsCitiesPath,
    hungarianLocales,
  )
  .addPathForLocales(
    'jobs-cities',
    italianJobsCitiesPath,
    italianLocales,
  )
  .addPathForLocales(
    'jobs-cities',
    flemishJobsCitiesPath,
    flemishLocales,
  )
  .addPathForLocales(
    'jobs-cities',
    dutchJobsCitiesPath,
    netherlandsLocales,
  )
  .addPathForLocales(
    'jobs-cities',
    russianJobsCitiesPath,
    russianLocales,
  )
  .addPathForLocales(
    'company-profiles',
    englishCompanyProfilesPath,
    [
      ...englishLocales,
      ...untranslatedLocales,
      ...portugueseLocales,
    ],
  )
  .addPathForLocales(
    'company-profiles',
    germanCompanyProfilesPath,
    germanLocales,
  )
  .addPathForLocales(
    'company-profiles',
    spanishCompanyProfilesPath,
    spanishLocales,
  )
  .addPathForLocales(
    'company-profiles',
    frenchCompanyProfilesMultilingualPath,
    frenchMultilingualLocales,
  )
  .addPathForLocales(
    'company-profiles',
    frenchCompanyProfilesPath,
    frenchNonMultilingualLocales,
  )
  .addPathForLocales(
    'company-profiles',
    hungarianCompanyProfilesPath,
    hungarianLocales,
  )
  .addPathForLocales(
    'company-profiles',
    italianCompanyProfilesPath,
    italianLocales,
  )
  .addPathForLocales(
    'company-profiles',
    flemishCompanyProfilesPath,
    flemishLocales,
  )
  .addPathForLocales(
    'company-profiles',
    dutchCompanyProfilesPath,
    netherlandsLocales,
  )
  .addPathForLocales(
    'company-profiles',
    russianCompanyProfilesPath,
    russianLocales,
  )
  .addPathForLocales(
    'company-ebp',
    englishProfilePagePath,
    [
      ...englishLocales,
      ...untranslatedLocales,
      ...portugueseLocales,
    ],
    'jobs',
  )
  .addPathForLocales(
    'company-ebp',
    germanProfilePagePath,
    germanLocales,
    'jobs',
  )
  .addPathForLocales(
    'company-ebp',
    spanishProfilePagePath,
    spanishLocales,
    'jobs',
  )
  .addPathForLocales(
    'company-ebp',
    frenchProfilePageMultilingualPath,
    frenchMultilingualLocales,
    'jobs',
  )
  .addPathForLocales(
    'company-ebp',
    frenchProfilePagePath,
    frenchNonMultilingualLocales,
    'jobs',
  )
  .addPathForLocales(
    'company-ebp',
    hungarianProfilePagePath,
    hungarianLocales,
    'jobs',
  )
  .addPathForLocales(
    'company-ebp',
    italianProfilePagePath,
    italianLocales,
    'jobs',
  )
  .addPathForLocales(
    'company-ebp',
    flemishProfilePagePath,
    flemishLocales,
    'jobs',
  )
  .addPathForLocales(
    'company-ebp',
    dutchProfilePagePath,
    netherlandsLocales,
    'jobs',
  )
  .addPathForLocales(
    'company-ebp',
    russianProfilePagePath,
    russianLocales,
    'jobs',
  )
  .addPathForLocales(
    'company-ebp-edit',
    englishEBPEditPath,
    [
      ...englishLocales,
      ...untranslatedLocales,
      ...portugueseLocales,
    ],
  )
  .addPathForLocales(
    'company-ebp-edit',
    germanEBPEditPath,
    germanLocales,
  )
  .addPathForLocales(
    'company-ebp-edit',
    spanishEBPEditPath,
    spanishLocales,
  )
  .addPathForLocales(
    'company-ebp-edit',
    frenchEBPEditMultilingualPath,
    frenchMultilingualLocales,
  )
  .addPathForLocales(
    'company-ebp-edit',
    frenchEBPEditPath,
    frenchNonMultilingualLocales,
  )
  .addPathForLocales(
    'company-ebp-edit',
    hungarianEBPEditPath,
    hungarianLocales,
  )
  .addPathForLocales(
    'company-ebp-edit',
    italianEBPEditPath,
    italianLocales,
  )
  .addPathForLocales(
    'company-ebp-edit',
    flemishEBPEditPath,
    flemishLocales,
  )
  .addPathForLocales(
    'company-ebp-edit',
    dutchEBPEditPath,
    netherlandsLocales,
  )
  .addPathForLocales(
    'company-ebp-edit',
    russianEBPEditPath,
    russianLocales,
  )
  .addPathForLocales(
    'job',
    englishJobPath,
    [
      ...englishLocales,
      ...untranslatedLocales,
      ...portugueseLocales,
      ...flemishLocales,
      ...frenchNonMultilingualLocales,
    ],
  )
  .addPathForLocales(
    'job',
    germanJobPath,
    germanLocales,
  )
  .addPathForLocales(
    'job',
    spanishJobPath,
    spanishLocales,
  )
  .addPathForLocales(
    'job',
    frenchJobMultilingualPath,
    frenchMultilingualLocales,
  )
  .addPathForLocales(
    'job',
    hungarianJobPath,
    hungarianLocales,
  )
  .addPathForLocales(
    'job',
    italianJobPath,
    italianLocales,
  )
  .addPathForLocales(
    'job',
    dutchJobPath,
    netherlandsLocales,
  )
  .addPathForLocales(
    'job',
    russianJobPath,
    russianLocales,
  )
  .addPathForLocales(
    'jobs',
    englishJobsPath,
    [
      ...englishLocales,
      ...untranslatedLocales,
      ...portugueseLocales,
    ],
  )
  .addPathForLocales(
    'jobs',
    germanJobsPath,
    germanLocales,
  )
  .addPathForLocales(
    'jobs',
    spanishJobsPath,
    spanishLocales,
  )
  .addPathForLocales(
    'jobs',
    frenchJobsMultilingualPath,
    frenchMultilingualLocales,
  )
  .addPathForLocales(
    'jobs',
    frenchJobsPath,
    frenchNonMultilingualLocales,
  )
  .addPathForLocales(
    'jobs',
    hungarianJobsPath,
    hungarianLocales,
  )
  .addPathForLocales(
    'jobs',
    italianJobsPath,
    italianLocales,
  )
  .addPathForLocales(
    'jobs',
    flemishJobsPath,
    flemishLocales,
  )
  .addPathForLocales(
    'jobs',
    dutchJobsPath,
    netherlandsLocales,
  )
  .addPathForLocales(
    'jobs',
    russianJobsPath,
    russianLocales,
  )
  .addPathForLocales(
    'jobs.onlyCityName',
    englishJobsCityPath,
    [
      ...englishLocales,
      ...untranslatedLocales,
      ...portugueseLocales,
    ],
    'jobs',
  )
  .addPathForLocales(
    'jobs.onlyCityName',
    germanJobsCityPath,
    germanLocales,
    'jobs',
  )
  .addPathForLocales(
    'jobs.onlyCityName',
    spanishJobsCityPath,
    spanishLocales,
    'jobs',
  )
  .addPathForLocales(
    'jobs.onlyCityName',
    frenchJobsMultilingualCityPath,
    frenchMultilingualLocales,
    'jobs',
  )
  .addPathForLocales(
    'jobs.onlyCityName',
    frenchJobsCityPath,
    frenchNonMultilingualLocales,
    'jobs',
  )
  .addPathForLocales(
    'jobs.onlyCityName',
    hungarianJobsCityPath,
    hungarianLocales,
    'jobs',
  )
  .addPathForLocales(
    'jobs.onlyCityName',
    italianJobsCityPath,
    italianLocales,
    'jobs',
  )
  .addPathForLocales(
    'jobs.onlyCityName',
    flemishJobsCityPath,
    flemishLocales,
    'jobs',
  )
  .addPathForLocales(
    'jobs.onlyCityName',
    dutchJobsCityPath,
    netherlandsLocales,
    'jobs',
  )
  .addPathForLocales(
    'jobs.onlyCityName',
    russianJobsCityPath,
    russianLocales,
    'jobs',
  )
  .addPathForLocales(
    'job-apply',
    englishJobApplyPath,
    [
      ...englishLocales,
      ...untranslatedLocales,
      ...portugueseLocales,
    ],
  )
  .addPathForLocales(
    'job-apply',
    germanJobApplyPath,
    germanLocales,
  )
  .addPathForLocales(
    'job-apply',
    spanishJobApplyPath,
    spanishLocales,
  )
  .addPathForLocales(
    'job-apply',
    frenchJobApplyMultilingualPath,
    frenchMultilingualLocales,
  )
  .addPathForLocales(
    'job-apply',
    frenchJobApplyPath,
    frenchNonMultilingualLocales,
  )
  .addPathForLocales(
    'job-apply',
    hungarianJobApplyPath,
    hungarianLocales,
  )
  .addPathForLocales(
    'job-apply',
    italianJobApplyPath,
    italianLocales,
  )
  .addPathForLocales(
    'job-apply',
    flemishJobApplyPath,
    flemishLocales,
  )
  .addPathForLocales(
    'job-apply',
    dutchJobApplyPath,
    netherlandsLocales,
  )
  .addPathForLocales(
    'job-apply',
    russianJobApplyPath,
    russianLocales,
  )
  .add(
    'job-form',
    '/dashboard/jobs/new',
    'job-form',
  )
  .add(
    'job-form-admin',
    '/dashboard/admin/jobs/new',
    'job-form-admin',
  )
  .add(
    'job-form-edit-admin',
    '/dashboard/admin/jobs/:jobId/edit',
    'job-form-edit-admin',
  )
  .add(
    'job-form-edit',
    '/dashboard/jobs/:jobId/edit',
    'job-form-edit',
  )
  .add(
    'profile-form',
    '/dashboard/profiles/new',
    'profile-form',
  )
  .add(
    'profile-form-edit',
    '/dashboard/profiles/:profileId/edit',
    'profile-form-edit',
  )
  .add(
    'logo-form',
    '/dashboard/logos/new',
    'logo-form',
  )
  .add(
    'templates',
    '/dashboard/templates',
    'dashboard/templates',
  )
  .add(
    'dashboardCategory',
    // eslint-disable-next-line max-len
    '/dashboard/lookbook/categories/:slug-:categoryId(\\d+){/search/:search(.*)}?',
    'dashboard/logos/gallery',
  )
  .add(
    'dashboardImage',
    '/dashboard/lookbook/{:slug-}?:id(\\d+)',
    'dashboard/logos/image',
  )
  .add(
    'templateForm',
    '/dashboard/templates/new',
    'dashboard/templates/new',
  )
  .add(
    'templateFormEdit',
    '/dashboard/templates/:templateId/edit',
    'dashboard/templates/edit',
  )
  .add(
    'article',
    `${maybePrefix}\
/${categoryPath}{/:slug}?/:createdAt(\\d{8}):id(\\d+)`,
    'article',
  )
  .add(
    'category',
    `${maybePrefix}/${categoryPath}`,
    'category',
  )
  .add(
    'category-tag',
    `${maybePrefix}/${categoryTagPage}/:categoryTagPath`,
    'category-tag',
  )
  .add(
    'category-tag.categories',
    `${maybePrefix}/${categoryTagPage}/categories/:categoryTagPath`,
    'category-tag',
  )
  .add(
    'job-versions',
    '/dashboard/jobs/:jobId/versions',
    'job-versions',
  )
  .add(
    'landing',
    // eslint-disable-next-line max-len
    `${maybePrefix}/:landingPrefix(landing|statistics|jobs|newsletter|cookies|company|privacy|privacy-statement|conditions|terms-of-use|code-of-ethics|fashionweekweb|business-intelligence|companydirectory|fashion-education-network|fashion-united-media|fashionunited-news|fashionunited-newsletter|fashionunited-career-center|network-and-social-media|about-us|contact|i|marketplace|global-fashion-industry-statistics|developers|handbook|docs|blog|zahlen-und-fakten-zur-deutschen-modeindustrie|statistieken-modebranche-nederland|uk-fashion-industry-statistics|diffusez-vos-offres-d-emploi|opublikovat-vakansii|ponga-su-anuncio|plaats-uw-vacatures)${isLiteInBrowser ? '?' : ''}{/:path(.+)}?`,
    'landing',
  )
  .add(
    'custom-article',
    `${maybePrefix}/:path((?!__nextjs_original-stack-frame).+)`,
    'article',
  );

const { Router } = routes;

const addPrefix = (intl, parameters) => {
  const prefix = intl.formatMessage(messages.prefix);

  if (prefix !== 'fr') {
    return parameters;
  }

  return {
    ...parameters,
    prefix,
  };
};

const addEventsPath = (intl, route, parameters) => {
  if (!(route || '').startsWith('event')) {
    return parameters;
  }

  const eventsPath = intl.formatMessage(messages.eventsPath);

  return {
    ...parameters,
    eventsPath,
  };
};

const addSearchPath = (intl, route, parameters) => {
  if (route !== 'search') {
    return parameters;
  }

  const searchPath = intl.formatMessage(messages.searchPath);

  return {
    ...parameters,
    searchPath,
  };
};

const updateEventsHref = (intl, route, href) => {
  if (!(route || '').startsWith('event')) {
    return href;
  }

  return `/${intl.formatMessage(messages.eventsPath)}`;
};

const Link = React.forwardRef((properties, reference) => {
  const intl = useIntl();
  const {
    route,
    params,
    to,
    children,
    passHref,
    scroll,
    onClick,
    href: originalHref,
    as: originalAs,
  } = properties;
  const nameOrUrl = route || to;
  const newParameters = addSearchPath(
    intl,
    route,
    addEventsPath(intl, route, addPrefix(intl, params)),
  );
  const { as, href } = nameOrUrl
    ? routes.findAndGetUrls(nameOrUrl, newParameters).urls
    : { as: originalAs, href: updateEventsHref(intl, route, originalHref) };

  return React.createElement(NextLink, {
    passHref,
    as,
    href,
    ref: reference,
    scroll,
    onClick,
    prefetch: false,
  }, children);
});

Link.displayName = 'Link';

Link.propTypes = {
  params: PropTypes.shape({}),
};

Link.defaultProps = {
  params: {},
};

Link.displayName = 'Link';

routes.Link = Link;

['pushRoute', 'replaceRoute'].forEach((routerMethodName) => {
  const routerMethod = Router[routerMethodName].bind(Router);

  Router[routerMethodName] = (route, originalParameters = {}, options) => {
    const parameters = getRelativePrefix(window.location.href) === '/fr' ? {
      ...originalParameters,
      prefix: 'fr',
    } : originalParameters;

    routerMethod(route, parameters, options);
  };
});

// eslint-disable-next-line unicorn/prefer-module
module.exports = routes;
